import * as React from 'react';
import {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import OutboundOrders from '../outbound-orders/OutboundOrders';
import OutboundOrderDetail from '../outbound-orders/OutboundOrderDetail';
import OutboundOrdersService from '../outbound-orders/OutboundOrdersService';
import {Company} from '../../shared/CommonInterfaces';
import OutboundOrdersManualCreate from '../outbound-orders/OutboundOrdersManualCreate';
import WarehouseService from '../../shared/services/WarehouseService';
import OutboundOrdersV2 from '../outbound-orders/OutboundOrdersV2';

interface AppProps {
  authenticityToken: string;
  currentCompany: Company;
  currentEnvironment: string;
  shipperHasOmniReservation: boolean;
  showOrderCancellationByCsvButton: boolean;
  showNewOrdersPage: boolean;
  showOrderReservations: boolean;
  distributionByLotReservationIds: string[];
  showCalculatedShipByDate: boolean;
}

function EcommerceOrdersApp(props: AppProps) {
  const outboundOrdersService = new OutboundOrdersService();
  const warehouseService = new WarehouseService(props.authenticityToken);
  const shipperId = props.currentCompany.id;
  const adminSignedIn = window.localStorage.getItem('adminSignedIn') === 'true';

  // Feature Flags
  const [createNewOrdersButtonFlagOn, setIsCreateNewOrdersButtonFlagOn] = useState<boolean>(false);
  const [attachmentsTabEnabled, setIsAttachmentsTabEnabled] = useState<boolean>(false);

  useEffect(() => {
    loadFeatureFlags(shipperId);
  }, [shipperId]);

  const getFeatureFlagValue = async (flag: string, shipperCompanyId: number = null) => {
    const featureFlagResponse = await warehouseService.getFeatureFlag(flag, null, null, shipperCompanyId, null);
    return !!featureFlagResponse.data.value;
  };

  const loadFeatureFlags = async (shipperCompanyId: number) => {
    const showAttachmentsTabEnabled = getFeatureFlagValue('attachments-tab-enabled', shipperCompanyId);
    const showCreateNewOrdersButtonFlagOn = getFeatureFlagValue(
      'add-create-order-button-in-ecommerce-page',
      shipperCompanyId
    );

    setIsAttachmentsTabEnabled(await showAttachmentsTabEnabled);
    setIsCreateNewOrdersButtonFlagOn(await showCreateNewOrdersButtonFlagOn);
  };

  return (
    <Router>
      <Switch>
        {
          <Route
            path="/s/fulfillment/orders"
            exact
            render={(routeProps) =>
              props.showNewOrdersPage ? (
                <OutboundOrdersV2
                  {...routeProps}
                  {...props}
                  outboundOrdersService={outboundOrdersService}
                  createNewOrdersButtonFlagOn={createNewOrdersButtonFlagOn}
                />
              ) : (
                <OutboundOrders
                  {...routeProps}
                  {...props}
                  outboundOrdersService={outboundOrdersService}
                  createNewOrdersButtonFlagOn={createNewOrdersButtonFlagOn}
                />
              )
            }
          />
        }
        {
          <Route
            path="/s/fulfillment/orders/new"
            exact
            render={(routeProps) => (
              <OutboundOrdersManualCreate {...routeProps} {...props} outboundOrdersService={outboundOrdersService} />
            )}
          />
        }
        {
          <Route
            path="/s/fulfillment/orders/:id"
            render={(routeProps) => (
              <OutboundOrderDetail
                {...routeProps}
                {...props}
                adminSignedIn={adminSignedIn}
                outboundOrdersService={outboundOrdersService}
                attachmentsTabEnabled={attachmentsTabEnabled}
              />
            )}
          />
        }
      </Switch>
    </Router>
  );
}
export default EcommerceOrdersApp;
